module.exports = __webpack_public_path__ + "static/img/98-2.474e1d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/98-2.jpg
// module id = lIrL
// module chunks = 0